<template>
	<div class="intro" v-if="currentData">
		<div v-if="!$store.state.endGame">
			<transition name="fade"> <PreCount v-if="startPrecount && !startGame" :currentData="currentData" :currentPlayer="currentPlayer" :currentWord="currentWord" v-on:start="realStart" /> </transition>

			<transition name="fade">
				<div v-if="startGame && wordData">
					<MainColumn class="center">
						<div class="header">
							<Logo size="tiny" color="blue" />
							<div class="score">
								<Scoring :color="currentData.color" :wordsPerGame="settings.wordsPerGame" :currentWord="currentWord" :score="score" />
							</div>

							<div class="word-info">
								<transition name="fade">
									<Meaning :label="wordData.type" :value="wordData.meaning" />
								</transition>
								<transition name="fade">
									<Synonym v-if="synonym" class="synonym" :synonyms="wordData.syn" />
								</transition>
							</div>

							<transition name="fade">
								<InputWord :color="currentData.color" :letter="letter" :hint="hints" v-on:update="checkGame" :word="wordData.word" />
							</transition>
						</div>

						<div class="content">
							<transition name="fade">
								<div class="inputs">
									<Status :color="currentData.color" :preCount="settings.preCount" :timeout="settings.timeout" v-on:score="(currentScore) => (wordScore = currentScore)" v-on:synonym="() => (synonym = true)" v-on:letter="onLetter" class="status" :wordData="wordData" />
									<Keyboard v-on:input="(output) => (letter = output)" />
								</div>
							</transition>
						</div>

						<EndRound :color="currentData.color" :currentPlayer="currentPlayer" :currentWord="currentWord" :wordsPerGame="settings.wordsPerGame" v-on:nextWord="nextWord" :status="$store.state.endRound" />
					</MainColumn>
				</div>
			</transition>
			<Confetti :boom="$store.state.endRound == 'win'" />
		</div>
		<transition name="fade">
			<EndGame v-on:restart="start()" v-if="$store.state.endGame" :settings="settings" />
		</transition>
	</div>
</template>

<script>
import Confetti from "@/components/Confetti.vue";
import EndGame from "@/components/EndGame.vue";
import EndRound from "@/components/EndRound.vue";
import InputWord from "@/components/InputWord.vue";
import Keyboard from "@/components/Keyboard.vue";
import Logo from "@/components/Logo.vue";
import MainColumn from "@/components/MainColumn.vue";
import Meaning from "@/components/Meaning.vue";
import PreCount from "@/components/PreCount.vue";
import Scoring from "@/components/Scoring.vue";
import Status from "@/components/Status.vue";
import Synonym from "@/components/Synonym.vue";

export default {
	components: {
		MainColumn,
		Logo,
		Meaning,
		InputWord,
		Keyboard,
		Status,
		Synonym,
		Scoring,
		PreCount,
		EndRound,
		EndGame,
		Confetti,
	},
	props: ["currentData", "settings", "currentPlayer"],
	data() {
		return {
			letter: false,
			musicPlayFasterTimer: false,
			startGame: false,
			startPrecount: false,
			seconds: 0,
			playbackRate: 1,

			countHints: 0,
			currentWord: 0,
			guessedWords: 0,
			hints: [],
			score: 0,
			status: false,
			synonym: false,
			used: [],
			wordData: false,
			wordScore: 0,
			wordsData: [],
		};
	},
	watch: {
		currentData: {
			handler(newValue) {
				this.updateData(newValue);
			},
			deep: true,
		},
		"$store.state.endRound"(value) {
			if (value == "lost") {
				this.wordsData[this.currentWord]["status"] = false;
				this.playAudio("lost", true);
			} else if (value == "win") {
				this.wordsData[this.currentWord]["status"] = true;
				this.playAudio("win", true);
			} else {
				this.playAudio("soundtrack", true);
			}
		},
	},
	methods: {
		realStart() {
			this.startGame = true;
			this.startPrecount = false;
			this.playAudio("soundtrack", true);
		},
		musicTempo() {
			this.musicPlayFasterTimer = setTimeout(() => {
				if (this.seconds > this.settings.timeout / 2 + this.settings.preCount && this.seconds < this.settings.timeout + this.settings.preCount) {
					this.playbackRate += 0.05;
					this.$store.state.sounds.soundtrack.playbackRate = this.playbackRate;
				}
				if (this.seconds < this.settings.timeout + this.settings.preCount) {
					this.musicTempo();
					console.log("chiamata");
				} else {
					clearTimeout(this.musicPlayFasterTimer);
					this.$store.state.sounds.soundtrack.playbackRate = 1;
					console.log("stop");
				}
				this.seconds++;
			}, 1000);
		},
		updateData(data) {
			//this.musicTempo();
			this.seconds = 0;
			this.playbackRate = 1;

			this.letter = false;
			this.musicPlayFasterTimer = false;
			this.startGame = false;
			this.startPrecount = false;
			this.status = false;

			this.countHints = false;
			this.currentWord = false;
			this.guessedWords = false;
			this.hints = false;
			this.score = false;
			this.synonym = false;
			this.used = false;
			this.wordData = false;
			this.wordScore = false;
			this.wordsData = false;

			setTimeout(() => {
				this.startPrecount = true;
				if (this.$store.state.players.length == 1 && this.$store.state.players[0].currentWord != 0) {
					this.startPrecount = false;
					this.startGame = true;
				}

				this.countHints = data.countHints;
				this.currentWord = data.currentWord;
				this.guessedWords = data.guessedWords;
				this.hints = data.hints;
				this.score = data.score;
				this.synonym = data.synonym;
				this.used = data.used;

				this.wordData = data.wordsData[data.currentWord];
				this.wordScore = data.wordScore;
				this.wordsData = data.wordsData;

				this.updateProperty({
					property: "backgroundColor",
					value: data.color,
				});
			}, 100);
		},
		onLetter(output) {
			this.hints = output;
			this.countHints++;
		},
		random(max) {
			if (max <= 2) return 0;
			let random = Math.floor(Math.random() * max);
			if (this.used.includes(random)) {
				return this.random(max);
			} else {
				this.used.push(random);
				return random;
			}
		},
		start() {
			this.updateData(this.currentData);
			this.$store.state.endGame = false;
			this.$store.state.endRound = false;
		},
		checkGame(letters) {
			switch (true) {
				case letters.join("") == this.wordData.word && this.countHints !== this.wordData.word.length:
					this.score = this.score + this.wordScore;
					this.guessedWords++;

					this.$store.state.endRound = "win";
					break;

				case this.countHints == this.wordData.word.length:
					this.$store.state.endRound = "lost";
					break;

				default:
			}
		},
		nextWord() {
			this.$emit("nextStep", this.currentWord, this.score, this.guessedWords);
			this.wordData = false;
			this.synonym = false;
			this.$store.state.endRound = false;
			this.hints = [];
			this.countHints = 0;
			for (let sound in this.$store.state.sounds) {
				this.$store.state.sounds[sound].playbackRate = 1;
			}
		},
	},
	mounted() {
		if (!this.$store.state.dictionary) {
			this.$router.push("/");
		}

		this.$store.state.sounds.intro.pause();
		this.$store.state.sounds.soundtrack.currentTime = 0;

		this.start();
	},
};
</script>
<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
.center {
	.header {
		z-index: 1000;
		position: relative;
		.score {
			position: absolute;
			right: 0;
			top: 0;
			display: inline-block;
			width: px(300);
		}
		.word-info {
			z-index: 10;
			width: px(600);
			display: inline-block;
			margin-top: px(10);
			max-width: 90%;
			@include breakpoint(s) {
				max-width: 100%;
			}
			.synonym {
				margin-top: px(-10);
				position: relative;
			}
		}
	}
	.content {
		position: fixed;
		bottom: px(30);
		left: 50%;
		transform: translateX(-50%);
		width: 100%;
		max-width: px(800);
		@include breakpoint(s) {
			width: 100%;
			bottom: -0.5rem;
		}

		.inputs {
			padding-top: px(25);
			margin-top: px(50);
			width: 100%;
			border-radius: px(50);
			border-top-left-radius: 0;
			border-top-right-radius: 0;
			position: relative;
			background: $mondadori-blue;
			padding-bottom: px(25);
			max-width: px(1024);
			@include breakpoint(s) {
				border-radius: 0;
			}

			.status {
				top: px(-31);
			}
		}
	}
}
</style>
